import React, { useEffect } from "react";
import { connect } from "react-redux";
import MarketingStreamPage from "./MarketingStream/MarketingStreamPage.js";
import { configureAmsService } from "../../../../../../../Service/OPSServices/StoreHealthServices/amsService.js";

function MarketingStream(props) {
  const token = props.token;
  if (token) {
    configureAmsService({
      getAuthHeader: () => (token.startsWith("Token ") ? token : `Token ${token}`),
    });
  }

  useEffect(() => {
    if (token) {
      configureAmsService({
        getAuthHeader: () => (token.startsWith("Token ") ? token : `Token ${token}`),
      });
    }
  }, [token]);

  return (
    <div className="animated fadeIn" style={{ width: "100%", paddingBottom: "30px" }}>
      <MarketingStreamPage token={token} />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    token: state.loggedUser.token,
  };
};

export default connect(mapStateToProps)(MarketingStream);
